module.exports = __webpack_public_path__ + "img/level-2.82bd3c29.png";